<div [ngClass]="getBodyClass()">
    <div class="container-fluid body-width">
        <!-- <app-swich-back-to-python  fromComp="main" [jobOnly]="jobOnly"></app-swich-back-to-python> -->
        @if(userRoleSwitch == 'Teacher' || userRoleSwitch == 'Group' || userRoleSwitch == ' GroupCoordinator' &&
        isAuthenticated) {

        }
        <router-outlet  *ngIf="permissionService.isPermissionsLoaded()"></router-outlet>
        <ngx-ui-loader></ngx-ui-loader>
        <app-status-popup></app-status-popup>
    </div>
</div>